/* eslint-disable jsx-a11y/control-has-associated-label */
/**
 *
 * SignUpStepTwo
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '@material-ui/core/ButtonBase';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import { MARKETING } from 'containers/Signup/constants';

const styles = theme => ({
  container: {
    marginTop: 8,
    marginBottom: 8,
  },
  email: {
    marginTop: 10,
    fontSize: 14,
    marginBottom: 4,
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
  },
  dividerItem: {
    flex: 1,
    height: 1,
    backgroundColor: '#CECECE',
  },
  dividerText: {
    color: '#CECECE',
    paddingLeft: 12,
    paddingRight: 12,
  },
  formContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  labelCheck: {
    fontSize: 11,
    lineHeight: 'unset',
  },
  marginNone: {
    margin: 0,
    padding: 0,
  },
  checkboxApply: {
    padding: '0',
    paddingRight: 5,
  },
  textFieldContainer: {
    '& label': {
      fontSize: '1.063rem',
    },
    '& input': {
      fontSize: '1.063rem',
    },
    '& select': {
      fontSize: '1.063rem',
    },
  },
  button: {
    background: theme.palette.text.secondary,
    color: '#ffffff',
    width: '100%',
    padding: 12,
    // marginTop: 16,
    marginBottom: 5,
    '&:hover': {
      opacity: 0.8,
    },
    ...theme.typography.pSmallBold,
  },
});

class SignUpStepTwo extends React.PureComponent {
  render() {
    const {
      classes,
      email,
      firstName,
      lastName,
      gender,
      age,
      marketing,
      onChange,
      onSubmit,
      onToggleMarketing,
    } = this.props;

    return (
      <>
        <Grid item xs={12}>
          <Typography
            variant="caption"
            align="center"
            className={classes.email}
          >
            {email}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <form className={classes.container} onSubmit={onSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  name="firstName"
                  classes={{
                    root: classes.textFieldContainer,
                  }}
                  fullWidth
                  label="First name"
                  value={firstName}
                  onChange={onChange}
                  type="text"
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="lastName"
                  classes={{
                    root: classes.textFieldContainer,
                  }}
                  fullWidth
                  label="Last name"
                  value={lastName}
                  onChange={onChange}
                  type="text"
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  classes={{ root: classes.textFieldContainer }}
                >
                  <InputLabel htmlFor="gender">Gender</InputLabel>
                  <NativeSelect
                    value={gender}
                    onChange={onChange}
                    inputProps={{
                      name: 'gender',
                      id: 'gender',
                    }}
                  >
                    <option value="" disabled />
                    <option value="Female">Female</option>
                    <option value="Male">Male</option>
                    <option value="Non-binary">Non-binary</option>
                    <option value="No-disclosure">
                      Prefer not to disclose
                    </option>
                    <option value="Other">Other</option>
                  </NativeSelect>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  classes={{ root: classes.textFieldContainer }}
                >
                  <InputLabel htmlFor="age">Age</InputLabel>
                  <NativeSelect
                    value={age}
                    onChange={onChange}
                    inputProps={{
                      name: 'age',
                      id: 'age',
                    }}
                  >
                    <option value="" disabled />
                    <option value="[<18]">Under 18</option>
                    <option value="[18-24]">18-24 years old</option>
                    <option value="[25-34]">25-34 years old</option>
                    <option value="[35-44]">35-44 years old</option>
                    <option value="[45-54]">45-54 years old</option>
                    <option value="[55-64]">55-64 years old</option>
                    <option value="[>65]">65 or older</option>
                  </NativeSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  classes={{
                    label: classes.labelCheck,
                    root: classes.marginNone,
                  }}
                  control={
                    <Checkbox
                      disableRipple
                      inputProps={{ 'aria-label': 'Toggle Marketing' }}
                      classes={{ root: classes.checkboxApply }}
                      checkedIcon={
                        <CheckBoxIcon
                          color="primary"
                          style={{ fontSize: 14 }}
                        />
                      }
                      icon={
                        <CheckBoxOutlineBlankIcon style={{ fontSize: 14 }} />
                      }
                      checked={marketing}
                      onChange={onToggleMarketing}
                    />
                  }
                  label={MARKETING}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonBase className={classes.button} type="submit">
                  SIGN UP
                </ButtonBase>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </>
    );
  }
}

SignUpStepTwo.propTypes = {
  classes: PropTypes.object,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  gender: PropTypes.string,
  age: PropTypes.string,
  marketing: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onToggleMarketing: PropTypes.func,
};

export default withStyles(styles)(SignUpStepTwo);
